export enum BidValuesEnum {
    MAX_BID = 400,
    LEGACY_MIN_BID = 50, // Legacy minimum - grandfathered for existing bids
    MIN_BID = 100, // New minimum for bids created after policy change
}